import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { FIELDS } from 'features/views/contactHistory/communicationInfo/form';
import { getSelectedGroup } from 'features/views/contactHistory/selectors';

export const NoteSection = () => {
	const communicationGroup = useSelector(getSelectedGroup);

	if (!communicationGroup) return null;

	return (
		!isNilOrEmpty(communicationGroup?.note) && (
			<Paper sx={{ p: 3, borderRadius: 2 }}>
				<Stack spacing={2}>
					<SectionHeader text={getLabelMessage('contactHistory:noteHeader')} />
					<Grid container>
						<Grid size={12}>
							<OutputTextField
								size="small"
								id={FIELDS.note}
								fullWidth
								value={communicationGroup.note}
								slotProps={{
									inputLabel: {
										shrink: !!communicationGroup.note,
									},
								}}
								multiline
							/>
						</Grid>
					</Grid>
				</Stack>
			</Paper>
		)
	);
};

export default NoteSection;
